import { BottomNavigation, BottomNavigationAction, Box, Paper } from "@mui/material";
import React, { useContext, useEffect, useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import StickyLinearProgress from "../../loading/StickyLinearProgress.tsx";
import { DashboardLayoutProps, NavigationPageItem } from "@toolpad/core";
import { AppFwAppProviderProps, AppFwAppProviderPropsContext } from "../../AppFwApp.tsx";


const NAV_HEIGHT = 56; // px

function isNavigationPageItem(object: any): object is NavigationPageItem {
    return 'segment' in object;
}

export default function MobileLayout(props: DashboardLayoutProps) {

    const appFwAppProviderProps = useContext<AppFwAppProviderProps>(AppFwAppProviderPropsContext)

    const navigate = useNavigate()
    const [activeSection, setActiveSection] = React.useState<undefined | NavigationPageItem>()

    const actions = useMemo(() => {
        const navigationPageItems = appFwAppProviderProps.navigation?.filter(isNavigationPageItem)
        return navigationPageItems?.map(navigationItem => {
            return <BottomNavigationAction
                key={navigationItem.segment}
                label={navigationItem.title}
                value={navigationItem}
                icon={navigationItem.icon}
                onClick={() => navigate(navigationItem.segment!!)}
            />
        })
    }, [appFwAppProviderProps.navigation])

    useEffect(() => {
        let path: null | string = location.pathname
        const navigationPageItems = appFwAppProviderProps.navigation?.filter(isNavigationPageItem)
        if (!navigationPageItems) {
            return
        }
        const activeSectionPath = navigationPageItems
            .find((navigationItem) => {
                return (navigationItem.segment && path?.startsWith(`/${navigationItem.segment}`))
            })
        if (activeSectionPath) {
            setActiveSection(activeSectionPath as NavigationPageItem)
        }
    }, [appFwAppProviderProps.navigation])

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100dvh',

                // pb: 16,
                pb: `${NAV_HEIGHT}px`, // Platz für die fixe BottomNav
            }}
        >
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                {props.children ?? <Outlet />}
            </Box>

            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                <StickyLinearProgress />
                <BottomNavigation
                    showLabels
                    value={activeSection}
                    onChange={(_: any, newValue: React.SetStateAction<string | undefined>) => {
                        setActiveSection(newValue as NavigationPageItem);
                    }}
                >
                    {actions}
                </BottomNavigation>
            </Paper>
        </Box>
    )
}
